
<template>
    
        <mars-view v-if="consultBox && consultBox.name" class="c-row consult-box" :class="{'suspend': isSuspension, 'consult-box-ios': !isAndroid}" @click.native="goLawyer"><mars-view class="l-span"><mars-view class="consult-box-img"><mars-view class="consult-box-img-box"><mars-image class="consult-box-img-item" :lazy-load="true" :src="consultBox.img" mode="heightFix"></mars-image></mars-view><mars-view class="consult-box-img-icon"></mars-view></mars-view><mars-view><mars-view class="consult-box-name">
                {{ consultBox.name }}
            </mars-view><mars-view class="consult-box-info"><mars-text class>{{ consultBox.head }}</mars-text><mars-text class>{{ consultBox.tail }}</mars-text></mars-view></mars-view></mars-view><mars-view v-if="consultBox.lawyerServiceNew && !consultBox.btnText" class="consult-box-btn" :class="isVip ? 'consult-box-btn-vip' : ''" @click.native="goLawyer('1')"><mars-text v-if="consultBox.lawyerServiceNew.service_type_new === 'phone_free_target_pre' || consultBox.lawyerServiceNew.service_type_new === 'phone_paid_target_pre'" class="consult-box-btn-number baidufont">
            {{ consultBox.lawyerServiceNew.service_type_new === 'phone_paid_target_pre' ? consultBox.lawyerServiceNew.pay : '0' }}
        </mars-text>
        {{
            consultBox.lawyerServiceNew.service_type_new === 'book_consult_target_pre'
                ? '预约咨询'
                : consultBox.lawyerServiceNew.service_type_new === 'phone_free_target_pre'
                    ? '元咨询'
                    : '/次'
        }}
        <login-btn v-if="isNeedLogin" :is-use-in-h5="consultBox.lawyerServiceNew.service_type_new !== 'phone_free_target_pre'" @callBackSucc="clickCall('1', true)"></login-btn></mars-view><mars-view v-else class="consult-box-btn" :class="isVip ? 'consult-box-btn-vip' : ''" @click.native="goLawyer('1')">
        {{ consultBox.btnText || '立即咨询' }}
        <login-btn v-if="isNeedLogin" :is-use-in-h5="consultBox.lawyerServiceNew.service_type_new !== 'phone_free_target_pre'" @callBackSucc="goLawyer('1', true)"></login-btn></mars-view><mars-view v-if="isSuspension" class="close-icon" @click.native.stop="close"></mars-view></mars-view>
    
</template>

<script>
import { act } from '../../static/utils/navigate.js';
import log from '../../static/utils/ubcLog';
import loginButton from "../../components/loginButton/index.vue";
export default {
  props: {
    // 是否是尊享会员
    isVip: {
      type: String,
      default: ''
    },
    consultBox: {
      type: Object,
      default() {
        return {};
      }
    },
    // 重写点击事件
    isRewriteEvent: {
      type: Boolean,
      default: false
    },
    // 是否悬浮展示
    isSuspension: {
      type: Boolean,
      default: false
    },
    // 是否需要判断登录
    isNeedLogin: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'login-btn': loginButton
  },
  data() {
    return {
      isAndroid: false
    };
  },
  mounted() {},
  methods: {
    getWebViewSystems() {
      let model = this.$api.getSystemInfoSync().model || '';
      if (model.includes('iPhone') && (model.includes('X') || model.includes('12') || model.includes('13') || model.includes('14') || model.includes('15') || model.includes('x'))) {
        return 'iOS';
      }
      return 'Android';
    },
    goLawyer(isConsult, refreshInfo = false) {
      if (this.isRewriteEvent) {
        if (isConsult === '1') {
          this.$emit('clickConsult', {
            area: 'qipao_click',
            refreshInfo
          });
        }
        return;
      }
      log.send({
        serverId: 17155,
        area: isConsult === '1' ? 'yd_bottom_lvshi_consult_click' : 'yd_bottom_lvshi_click',
        action: 'click'
      });
      const {
        target_url
      } = this.consultBox.lawyerServiceNew || {};
      if (isConsult === '1') {
        act({
          target: target_url,
          type: 'url'
        });
        return;
      }
      act({
        target: target_url.replace('action=consult', 'action='),
        type: 'url'
      });
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.consult-box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 0.6px solid #e6e6e6;
  z-index: 10;
  margin: 0;
  padding: 10px 17px;
  background: #fff;
  justify-content: space-between;
  align-items: flex-start;
}
.consult-box-img {
  width: 0.42rem;
  height: 0.42rem;
  background-image: linear-gradient(-39deg, #9ea0b1 0%, #c7c9d5 99%);
  border: 1px solid #f5f6f9;
  position: relative;
  border-radius: 50%;
  margin-right: 0.1rem;
}
.consult-box-img-box {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.consult-box-img-item {
  width: 100%;
  height: 100%;
}
.consult-box-img-icon {
  width: 0.14rem;
  height: 0.14rem;
  position: absolute;
  right: 0;
  bottom: 0;
  background: url("https://lvlin-base.cdn.bcebos.com/law/pages/exporthome/light.png") no-repeat;
  background-size: 100% 100%;
}
.consult-box-name {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 0.16rem;
  color: #1e1f24;
  line-height: 1;
}
.consult-box-info {
  font-family: PingFangSC-Regular;
  font-size: 0.13rem;
  color: #848691;
  line-height: 1;
  margin-top: 0.07rem;
}
.consult-box-btn {
  width: 1.68rem;
  height: 0.39rem;
  background: #05f;
  border-radius: 0.195rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 0.17rem;
  color: #fff;
  text-align: center;
  line-height: 0.39rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.consult-box-btn-vip {
  width: 1.68rem;
  height: 0.39rem;
  background: #fed9b9;
  border-radius: 0.195rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 0.17rem;
  color: #401611;
  text-align: center;
  line-height: 0.39rem;
}
.consult-box .close-icon {
  height: 0.12rem;
  width: 0.12rem;
  position: absolute;
  right: 0.13rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/lawyer-home/close-icon.png') no-repeat center center / 100% 100%;
}
.consult-box.suspend {
  bottom: 0.77rem;
  box-shadow: 0 0.04rem 0.17rem 0 rgba(118, 118, 118, 0.18);
  border-radius: 0.1rem;
  align-items: center;
  margin: 0 0.08rem;
  padding: 0.13rem 0.38rem 0.13rem 0.13rem;
  border: none;
  margin-bottom: env(safe-area-inset-bottom);
  margin-bottom: constant(safe-area-inset-bottom);
}
.consult-box.suspend .consult-box-btn {
  height: 0.32rem;
  width: 0.82rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 0.14rem;
  color: #fff;
  text-align: center;
  line-height: 0.32rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.consult-box.suspend .consult-box-btn-vip {
  color: #401611;
}
.consult-box .consult-box-btn-number {
  display: inline;
  font-size: 0.18rem;
}
.consult-box .consult-box-img-box {
  position: relative;
}
.consult-box .consult-box-img-box .consult-box-img-item {
  width: 100%;
  height: 100%;
}
.consult-box .consult-box-img-box .consult-box-img-item /deep/ [class*="image-inner"] {
  background-size: auto 100%;
  background-position: center;
}
.consult-box-ios {
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}

</style>
